/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Add_CurrentInputs */

const en_add_current = /** @type {(inputs: Add_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add Current`)
};

const es_add_current = /** @type {(inputs: Add_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agregar actual`)
};

const fr_add_current = /** @type {(inputs: Add_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter l'actuelle`)
};

const de_add_current = /** @type {(inputs: Add_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktuelle hinzufügen`)
};

const ja_add_current = /** @type {(inputs: Add_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現在のページを追加`)
};

const zh_add_current = /** @type {(inputs: Add_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`添加当前页`)
};

const ar_add_current = /** @type {(inputs: Add_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إضافة الحالية`)
};

const id_add_current = /** @type {(inputs: Add_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tambahkan Saat Ini`)
};

const it_add_current = /** @type {(inputs: Add_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungi Corrente`)
};

const ru_add_current = /** @type {(inputs: Add_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Добавить текущую`)
};

const pt_add_current = /** @type {(inputs: Add_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar Atual`)
};

const ko_add_current = /** @type {(inputs: Add_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`현재 페이지 추가`)
};

/**
* | output |
* | --- |
* | "Add Current" |
*
* @param {Add_CurrentInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const add_current = /** @type {((inputs?: Add_CurrentInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Add_CurrentInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_add_current(inputs)
	if (locale === "es") return es_add_current(inputs)
	if (locale === "fr") return fr_add_current(inputs)
	if (locale === "de") return de_add_current(inputs)
	if (locale === "ja") return ja_add_current(inputs)
	if (locale === "zh") return zh_add_current(inputs)
	if (locale === "ar") return ar_add_current(inputs)
	if (locale === "id") return id_add_current(inputs)
	if (locale === "it") return it_add_current(inputs)
	if (locale === "ru") return ru_add_current(inputs)
	if (locale === "pt") return pt_add_current(inputs)
	return ko_add_current(inputs)
});